import { CfSliderProps } from "../types";
import React from "react";
import Slider from "..";

export const convertCfSliderProps = ({ slug, children }: CfSliderProps) => {
  return {
    id: slug || "",
    autoplay: { delay: 6500 },
    children,
  };
};

const CfSlider = (props: CfSliderProps) => (
  <Slider {...convertCfSliderProps(props)} />
);

export default CfSlider;
